import { useLocationsRetrieve } from "@sidegigllc/api/client";
import { useAuth } from "domains/auth";
import { hasJobsAccess } from "domains/hire/access/jobsAccess";
import { useFeatureFlag } from "providers/LaunchDarkly";
import { useActiveLocationId } from "services/locationOrgContext";

/**
 * Single source of truth for whether the Jobs feature is exposed in the UI.
 *
 * Gated by:
 *  1. The global LD `jobs-phased` flag (rollout switch).
 *  2. The active Location's `jobs_enabled` field (per-location admin override).
 *  3. The user not being an onsite manager at the active location.
 *
 * Treats absent `jobs_enabled` as `true` so the FE keeps current behavior during
 * the deployment window before the backend ships the field.
 */
export const useHasJobsAccess = (): boolean => {
  const { user } = useAuth();
  const [activeLocationId] = useActiveLocationId();
  const { data: activeLocation } = useLocationsRetrieve(activeLocationId ?? -1, {
    query: { enabled: !!activeLocationId },
  });
  const jobsPhased = useFeatureFlag("jobs-phased");
  return hasJobsAccess({
    jobsPhased,
    jobsEnabled: activeLocation?.jobs_enabled,
    user,
    locationId: activeLocationId ?? -1,
  });
};
